import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'app-cabecalho',
    templateUrl: './cabecalho.component.html',
    styleUrls: ['./cabecalho.component.scss'],
})
export class CabecalhoComponent {
    @Input() titulo: string = '';
    @Input() voltar: boolean = false;
    @Output() voltarChange = new EventEmitter<void>();

    constructor(
        public router: Router,
    ) { }

    public home() {
        this.router.navigate(['home']);
    }

    public onVoltar() {
        this.voltarChange.emit();
    }
}
